export default "__VITE_ASSET__DIt7345N__";